module.exports = __webpack_public_path__ + "static/media/quit.2212f284.svg";